import { render, staticRenderFns } from "./OpenFolderInfo.vue?vue&type=template&id=3f550d59&scoped=true&"
import script from "./OpenFolderInfo.vue?vue&type=script&lang=js&"
export * from "./OpenFolderInfo.vue?vue&type=script&lang=js&"
import style0 from "./OpenFolderInfo.vue?vue&type=style&index=0&id=3f550d59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f550d59",
  null
  
)

export default component.exports